<template>
    <div id="app" style="display: flex">
        <div v-if="admin">
          <AdminSidebar v-if="logged"/>
        </div>
        <div v-else>
          <Sidebar v-if="logged"/>
        </div>
        <div style="width: 100%">
            <Topbar v-if="logged"/>
                <router-view></router-view>
        </div>
    </div>
</template>
<script>
import Topbar from '@/components/Topbar.vue'
import Sidebar from '@/components/Sidebar.vue'
import AdminSidebar from '@/components/AdminSidebar.vue'
import Cases from '@/views/Cases.vue'

export default {
    updated: function(){
      this.checkToken();
      this.getUser();
    },
    beforeMount: function(){
      this.checkToken();
      this.getUser();    
    },
    name: 'app',
    components: {
        Topbar,
        Sidebar,
        AdminSidebar,
        Cases,
    },
    data(){
      return {
        user: {},
        logged: false,
        admin: false,
      }
    },
    methods: {
      checkToken(){
        let token = localStorage.getItem("session_id");
        if (token){
          this.logged = true;
        } else {
          this.logged = false;
          localStorage.clear();
          this.$router.push("/");
        }
      },
      getUser(){
        let user = JSON.parse(localStorage.getItem("user"));

        if (user){
          this.user = user;
          if(user.type == "admin"){
            this.admin = true;
          } else {
            this.admin = false;
          }
        } else {
          this.logged = false;
          this.user = {};
          localStorage.clear();
          this.$router.push("/");
        }

      }
    }
}
</script>
<style lang="scss">
    /*Bootstrap imports*/
    @import "../node_modules/bootstrap/scss/functions";
    @import "../node_modules/bootstrap/scss/variables";
    @import "../node_modules/bootstrap/scss/mixins/_breakpoints";
    @import "../node_modules/bootstrap/scss/bootstrap";



    @import "assets/scss/sb-admin/variables";
    @import "assets/scss/sb-admin/global";
    @import "assets/scss/sb-admin/utilities";
    @import "assets/scss/sb-admin/dropdowns";
    @import "assets/scss/sb-admin/navs";

</style>

